import WeatherLocationType from 'owa-service/lib/contract/WeatherLocationType';
import findWeatherLocationsService from '../services/FindWeatherLocationsService';
import { getLocationTypeFromLocationId } from './locationTypeConversionUtils';
import PersonaPostalAddress from 'owa-service/lib/contract/PersonaPostalAddress';
import { trace } from 'owa-trace';
import { format } from 'owa-strings';

export async function findWeatherLocationFromPostalAddress(
    postalAddress: PersonaPostalAddress
): Promise<WeatherLocationType> {
    let queryString = format(
        '{0}, {1}, {2}',
        postalAddress.City,
        postalAddress.State,
        postalAddress.Country
    );
    return findWeatherLocation(queryString);
}

export async function findWeatherLocationFromLatLong(
    latitude: number,
    longitude: number
): Promise<WeatherLocationType> {
    let queryString = latitude + ',' + longitude;
    return findWeatherLocation(queryString);
}

export async function findWeatherLocation(queryString: string): Promise<WeatherLocationType> {
    return findWeatherLocationsService(queryString)
        .then(response => {
            if (response.WeatherLocationIds && response.WeatherLocationIds.length > 0) {
                let locationId = response.WeatherLocationIds[0];
                let locationType = getLocationTypeFromLocationId(locationId);
                return Promise.resolve(locationType);
            }
            return Promise.resolve(null);
        })
        .catch(reason => {
            /**
             * The API for only getting cities from the location bing search isn't finished yet, so it's currently possible
             * to try to request weather from locations that don't resolve in the weather API, which throws errors. We'll
             * catch those here and prevent the throw from breaking the entire options page
             */
            trace.warn('failed to find location: ' + reason);
            return Promise.resolve(null);
        });
}
